import { render, staticRenderFns } from "./GerarDocAssociado.vue?vue&type=template&id=59765b0f"
import script from "./GerarDocAssociado.vue?vue&type=script&lang=js"
export * from "./GerarDocAssociado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports